// extracted by mini-css-extract-plugin
export default {"strip":"CaixaStrip_strip__xQuUY","caixaBadge":"CaixaStrip_caixaBadge__hk9YQ","text":"CaixaStrip_text__nmOoW"};